import {
  HiredInsuranceProductType,
  type ContractedService,
} from '~/domain/Assegurou/contractedServices';
import type { ContractedServicesDTO } from '~/dto/Assegurou/contractedServices';
import { contractedServiceDTOtoContractedService } from '~/mappers/Assegurou/contractedServices';
import apiAssegurou from '~/services/apiAssegurou';

export async function getContractedServicesUseCase(
  document: string
): Promise<ContractedService[]> {
  try {
    const response = await apiAssegurou.get<ContractedServicesDTO>(
      `/v1/Protecao/ListarSeguros?CpfSegurado=${document}`
    );

    const notCanceledInsurances = response.data.resultData.seguros.filter(
      (insurance) =>
        !(
          insurance.cancelamentoDataHora !== null &&
          insurance.codigoProduto === HiredInsuranceProductType.MARISA_AUTO
        )
    );

    return notCanceledInsurances.map(contractedServiceDTOtoContractedService);
  } catch {
    return [];
  }
}
